module.exports = __webpack_public_path__ + "static/media/gnbbookpi.d7eeeec1.png";